import { render, staticRenderFns } from "./SpecialCounter.vue?vue&type=template&id=08ab5a40&scoped=true"
import script from "./SpecialCounter.vue?vue&type=script&lang=js"
export * from "./SpecialCounter.vue?vue&type=script&lang=js"
import style0 from "./SpecialCounter.vue?vue&type=style&index=0&id=08ab5a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab5a40",
  null
  
)

export default component.exports